import React, { Component } from 'react';
import Head from '../../../../components/Head/Head';
import Auxiliary from '../../../../hoc/Auxiliary/Auxiliary';
import { withTranslation } from 'react-i18next';
import OutsourcingRisksBanner from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingRisks/OutsourcingRisksBanner/OutsourcingRisksBanner';
import OutsourcingRisks2 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingRisks/OutsourcingRisks2/OutsourcingRisks2';
import OutsourcingRisks3 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingRisks/OutsourcingRisks3/OutsourcingRisks3';
import OutsourcingRisks4 from '../../../../components/Services/Pilars/outsourcing/satellites/outsourcingRisks/OutsourcingRisks4/OutsourcingRisks4';

class OutsourcingRisks extends Component {
    render() {
        return (
            <Auxiliary>
                <Head id="outsourcing-risks" />
                <OutsourcingRisksBanner {...this.props} />
                <OutsourcingRisks2 {...this.props} />
                <OutsourcingRisks3 {...this.props} />
                <OutsourcingRisks4 {...this.props} />
                <div className='custom-end-outsourcing-risks'></div>
            </Auxiliary>
        );
    }
}

export default withTranslation()(OutsourcingRisks);
